import { Component, ElementRef, HostListener, inject, Input, Output, ViewChild } from '@angular/core';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { FrontendEnaioMapper } from 'src/modules/enaio/models/frontend-enaio-mapper.model';
import { EnaioDbDataType } from 'src/modules/enaio/shared/EnaioDbDataType';
import { EnaioDocument } from 'src/modules/enaio/shared/EnaioDocument';
import { EnaioGuiControlType } from 'src/modules/enaio/shared/EnaioGuiControlType';
import { EnaioGuiField } from 'src/modules/enaio/shared/EnaioGuiField';
import { FrontendFieldDefinition } from 'src/modules/sm-base/models/frontend-field-definition.model';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
  selector: 'app-enaio-form',
  templateUrl: './enaio-form.component.html',
  styleUrl: './enaio-form.component.scss'
})
export class EnaioFormComponent {

    app = inject(MainAppService);

    _fields: EnaioGuiField[];
    _doc: EnaioDocument;
    _displayHiddenFields = false;
    _infoInTooltip = true;
    _displayInternalNames = false;

    form: FrontendFormDefinition;

    @ViewChild("formRef", { static: false }) formRef: ElementRef;
    
    @Input()
    set fields(value: EnaioGuiField[]) {
        this._fields = value;
        this.generateForm();
    }

    @Input()
    set displayHiddenFields(value: boolean) {
        this._displayHiddenFields = value;
        this.generateForm();
    }

    get displayHiddenFields(): boolean {
        return this._displayHiddenFields;
    }

    @Input()
    set infoInTooltip(value: boolean) {
        this._infoInTooltip = value;
        this.generateForm();
    }

    get infoInTooltip(): boolean {
        return this._infoInTooltip;
    }

    @Input()
    set displayInternalNames(value: boolean) {
        this._displayInternalNames = value;
        this.generateForm();
    }

    get displayInternalNames(): boolean {
        return this._displayInternalNames;
    }

    @Input()
    set doc(value: EnaioDocument) {
        this._doc = value;
        this.generateForm();
    }

   /* @HostListener('click', ['$event']) 
    onClick(event: MouseEvent): void {
        const clickedElement = event.target as HTMLElement;
    
        let closest = clickedElement.closest('app-sm-form-field');
        if (closest != null) {
            const childComponent = ng.getComponent(closest);
    
        }
        
      }
*/
    generateForm(): void {
        if (this._fields == null) {
            this.form = null;
        }
        else {
            let allFields = Utils.arrayExplode(this._fields, f => [f, ...Utils.arrayExplode(f.pages, p => p.fields)]);
            this.form = FrontendEnaioMapper.enaioToFrontendForm(this._fields, this.app, "", [], true);
            this.form.mandatoryFieldsRedAsterisk = false;
            for (let field of this.form.getAllFields()) {
                let ef = allFields.find(f2 => f2.wfFieldId == field.id || f2.internalName == field.id);
                if (this._infoInTooltip) {
                    if (ef != null) {
                        field.tooltipStyleClasses = "monospace";
                        field.tooltipOnControl = true;
                        field.tooltip = 
                            "Name:          " + ef.name + "\n" +
                            "Interner Name: " + ef.internalName + "\n" +
                            "Datenbankname: " + ef.dbFieldName + "\n" + 
                            "Länge:         " + ef.maxLength + "\n" +
                            "Datentyp:      " + EnaioDbDataType.getName(ef.dataType) + "\n" +
                            "GUI-Typ:       " + EnaioGuiControlType.getName(ef.controlType2) + "\n" +
                            "Versteckt:     " + (ef.isControlVisible ? "Nein" : "Ja")
                        field.tooltip = field.tooltip.replace(/ /g, "\u00a0");
                    }                    
                }
                if (this._displayHiddenFields) {
                    field.hasLabel = true;
                    field.hasControl = true;
                }
                if (this._displayInternalNames && ef != null) {
                    field.caption = ef.internalName;
                }
            }
            
            if (this._doc != null) {
                for (let field of this._doc.metaData) {
                    this.form.setValue(field.field.internalName, field.value);
                }
            }
        }
    }
}

/*

        
        for (let field of this.maskForm.fields) {
            let mf = mask.fields.find(f => f.guiField.wfFieldId == field.id);
            let dataFields = this.getDataFieldsForMaskField(apps, mf);
            field.tooltip = Utils.arrayItemsToString(Utils.arrayGetUnique(dataFields.map(df => df.name + " (" + df.id + ")")), "\n");
            field.tooltipOnControl = true;
        }*/